import React from 'react'
import * as styles from './styles.module.scss'

const Hamburger = ({ open, onClick }) => {
  const menuTitle = open ? 'Close' : 'Menu'
  const squeezeClass = open ? styles.Squeeze : undefined

  return (
    <button
      className={[styles.Hamburger, squeezeClass].join(' ')}
      onClick={onClick}
    >
      <span className={styles.Box}>
        <span className={styles.Inner}></span>
      </span>
      <span className={styles.Menu}>{menuTitle}</span>
    </button>
  )
}

export default Hamburger
